import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Grid,
  Typography,
  makeStyles,
  Box,
  Breadcrumbs,
  Link,
  SvgIcon,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles((theme) => ({
  root: { color: theme.palette.text.primary }
}));

const Header = ({
  className,
  icon: Icon,
  text,
  link,
  previousText,
  previousLink,
  ...rest
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      justify="space-between"
      spacing={3}
      {...rest}
    >
      <Grid item>
        <Box mb={1}>
          {previousText && (
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Link color="inherit" to={previousLink} component={RouterLink}>
                {previousText}
              </Link>
              <Typography color="textPrimary">{text}</Typography>
            </Breadcrumbs>
          )}
        </Box>
        <Box display="flex" alignItems="center">
          {Icon && (
            <SvgIcon fontSize={!mobileDevice ? 'large' : undefined}>
              <Icon />
            </SvgIcon>
          )}
          <Box mr={1} />
          <Typography variant={mobileDevice ? 'h5' : 'h3'} color="textPrimary">
            {text}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  previousText: PropTypes.string,
  previousLink: PropTypes.string,
  icon: PropTypes.elementType
};

export default Header;
